import React from "react";
import DeliveryManTable from "../DeliveryManListTable";

const DeliveryManList = () => {
  return <DeliveryManTable type="verified" />;
};

export default DeliveryManList;
